module.exports = __webpack_public_path__ + "Mark-Simonson-Proxima-Nova-Alt-Regular-webfont.0b420bac468e8340b6dd.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Regular-webfont.ttf
// module id = ../../../../../src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Regular-webfont.ttf
// module chunks = main styles